import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-61b57930"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "app-page"
};
const _hoisted_2 = {
  class: "app-page-header"
};
const _hoisted_3 = {
  class: "app-page-menu"
};
const _hoisted_4 = {
  class: "page-menu-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "app-page-user"
};
const _hoisted_7 = {
  class: "page-menu-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "page-menu-item username"
};
const _hoisted_10 = {
  class: "app-page-content"
};
const _hoisted_11 = {
  class: "app-main"
};
import { reactive, ref, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { menus } from '../constants/system';
import { ElMessage } from 'element-plus';
/**
 * data
 */

import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: 'Layout'
});

export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    let userType = '';
    const pageLoad = ref(false);
    const menuData = reactive({
      list: [],
      userTabs: [{
        label: '修改密码',
        name: 'modifyPassword'
      }, {
        label: '退出登录',
        name: 'logout'
      }],
      reactive: 'home'
    });
    const username = ref('');
    const router = useRouter(),
          route = useRoute();
    const store = useStore();
    /**
     * methods
     */

    const menuChange = name => {
      menuData.reactive = name;
      router.push({
        name
      });
    };

    const userMenuChange = name => {
      if (name === 'logout') {
        store.commit('user/logout');
        window.location.href = '/login';
      } else {
        menuData.reactive = name;
        router.push({
          name
        });
      }
    };

    const init = () => {
      userType = store.state.user.userType;
      menuData.list = menus[userType];
      menuData.reactive = route.name;
      username.value = store.state.user.userInfo.name;
    }; // 获取省市区


    const areaCascaderInit = () => {
      pageLoad.value = true;
      setTimeout(() => {
        store.dispatch('appData/getAddress').then(() => {
          pageLoad.value = false;
        }).catch(error => {
          console.log(error);
          ElMessage.error('获取地址信息失败，请刷新浏览器');
        });
      }, 500);
    };
    /**
     *  生命周期
     */


    onBeforeMount(() => {
      init();
      areaCascaderInit();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.list, item => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass({
            'page-menu-item': true,
            'active': menuData.reactive === item.name
          }),
          key: item.name,
          onClick: $event => menuChange(item.name)
        }, _toDisplayString(item.label), 11, _hoisted_5);
      }), 128))])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.userTabs, item => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass({
            'page-menu-item': true,
            'active': menuData.reactive === item.name
          }),
          key: item.name,
          onClick: $event => userMenuChange(item.name)
        }, _toDisplayString(item.label), 11, _hoisted_8);
      }), 128)), _createElementVNode("li", _hoisted_9, _toDisplayString(username.value), 1)])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [!pageLoad.value ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0
      })) : _createCommentVNode("", true)])])])), [[_directive_loading, pageLoad.value]]);
    };
  }

});